<template>
    <section>
        <el-row>
            <el-col :span="24">
                <!--表单-->
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item label="标题">
                        <el-input v-model="formInline.BT" placeholder="标题" style="width: 280px;"></el-input>
                    </el-form-item>
                    <el-form-item label="年份">
                        <el-date-picker
                                v-model="formInline.CJSJ"
                                align="right"
                                type="year"
                                placeholder="选择年份">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="作者">
                        <el-input v-model="formInline.CZZ" placeholder="作者" style="width: 280px;"></el-input>
                    </el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form>
                <!--表格-->
                <el-table
                        :data="tableData"
                        border
                        style="width: 100%">
                    <el-table-column type="selection">
                    </el-table-column>
                    <el-table-column
                            prop="BT"
                            width="420"
                            label="标题">
                    </el-table-column>
                    <el-table-column
                            prop="ID"
                            v-if="show"
                            label="ID">
                    </el-table-column>
                    <el-table-column
                            prop="NR"
                            v-if="show"
                            label="ID">
                    </el-table-column>
                    <el-table-column
                            prop="XSSX"
                            width="90"
                            align="center"
                            label="显示顺序">
                    </el-table-column>
                    <el-table-column
                            prop="CZZ"
                            label="作者"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="WLDZ"
                            label="外链地址"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="CJSJ"
                            align="center"
                            label="创建日期"
                            width="180">
                    </el-table-column>
                    <el-table-column label="操作">
                        <template scope="scope">
                            <el-button type="primary" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                            <el-button type="danger" size="small" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="block">
                    <!--<el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="100"
                            layout="prev, pager, next, jumper"
                            :total="1000">
                    </el-pagination>-->
                    <el-pagination
                            background
                            layout="prev, pager, next"
                            next-text="下一页"
                            :small="true"
                            :page-size="5"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :total="totalCount"
                    >
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
        <el-dialog title="修改新闻信息" :visible="dialogFormVisible" size="tiny"  @close='dialogFormVisible = false'>
            <el-form ref="form" :model="form" label-width="">
                <el-form-item label="ID" v-if="show">
                    <el-input v-model="form.ID"></el-input>
                </el-form-item>
                <el-form-item label="标题">
                    <el-input v-model="form.BT"></el-input>
                </el-form-item>
                <el-form-item label="显示顺序">
                    <el-input v-model="form.XSSX"></el-input>
                </el-form-item>
                <el-form-item label="外链地址">
                    <el-input v-model="form.WLDZ"></el-input>
                </el-form-item>
                <el-form-item class="zwnr">
                    <UEditor  :config="myConfig" ref="ueditor" :defaultMsg="defaultMsg"></UEditor>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSave" :loading="editLoading">修改</el-button>
                    <el-button @click="dialogFormVisible = false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </section>
</template>
<script type="text/ecmascript-6">
    import UEditor from '../../components/ueditor/ueditor.vue'
    import {mapActions} from "vuex";
    const ERR_OK = "000";
    export default {
        name:'xwwh',
        components: {UEditor},
        data () {
            return {
                defaultMsg: '',
                show:false,
                cxlx:this.$route.query.cxlx==null?5:this.$route.query.cxlx,
                totalCount:50,
                currentPage:1, //初始页
                pagesize:5,    //    每页的数据
                papercount:5,
                formInline: {
                    BT:'',
                    CJSJ:'',
                    CZZ:''
                },
                myConfig: {
                    // 如果需要上传功能,找后端小伙伴要服务器接口地址
                    serverUrl: this.$config.baseUrl + 'ueditor/ueditorConfig',
                    // 你的UEditor资源存放的路径,相对于打包后的index.html
                    UEDITOR_HOME_URL: '/ueditor/',
                    // 编辑器不自动被内容撑高
                    autoHeightEnabled: false,
                    // 工具栏是否可以浮动
                    autoFloatEnabled: false,
                    // 初始容器高度
                    initialFrameHeight: 340,
                    // 初始容器宽度
                    initialFrameWidth: '100%',
                    // 关闭自动保存
                    enableAutoSave: true
                },
                content: '',
                tableData: [],
                options: [],
                places: [],
                dialogFormVisible: false,
                editLoading: false,
                form: {
                    ID:'',
                    BT: '',
                    XSSX: '',
                    WBNR: '',
                    NR:''
                },
                table_index: 999,
            };
        },
        created () {
            this.handleUserList();
        },
        methods: {
            ...mapActions([
                'Ymxxinit','zcxwSave'
            ]),
            // 初始页currentPage、初始每页数据数pagesize和数据data
            handleSizeChange: function (size) {
                this.pagesize = size;
                console.log(this.pagesize)  //每页下拉显示数据
            },
            handleCurrentChange: function(currentPage){
                this.currentPage = currentPage;
                console.log(this.currentPage)  //点击第几页
                this.handleUserList();
            },
            handleUserList() {
                let cjsj=this.formInline.CJSJ==""?"":this.formInline.CJSJ.getFullYear();
                this.Ymxxinit({_module:'TT',_method:'getZcfgxxInit',bt:this.formInline.BT,czz:this.formInline.CZZ,cjsj:cjsj,"numPerPage": this.pagesize,"pageNum": this.currentPage,cxlx:this.cxlx}).then((res) => {  //这是从本地请求的数据接口，
                    this.tableData = res._page.results;
                    this.totalCount=res._page.count;
                })
            },
            onSubmit () {
                if(this.formInline.BT ==""&&this.formInline.CZZ==""&&this.formInline.CJSJ==""){
                    this.$message('查询条件不能为空');
                }else {
                    let cjsj=this.formInline.CJSJ==""?"":this.formInline.CJSJ.getFullYear();
                    this.Ymxxinit({_module:'TT',_method:'getZcfgxxInit',bt:this.formInline.BT,czz:this.formInline.CZZ,cjsj:cjsj,"numPerPage": this.pagesize,"pageNum": this.currentPage,cxlx:this.cxlx}).then((res) => {  //这是从本地请求的数据接口，
                        this.tableData = res._page.results;
                        this.totalCount=res._page.count;
                    })
                }
            },
            handleDelete (index, row) {
                this.tableData.splice(index, 1);
                this.zcxwSave({_module:'TT',_method:'czxwDelete',id:row.ID,"lx": 1,}).then((res) => {  //这是从本地请求的数据接口，
                    if(res._result.type=="success"){
                        this.tableData.splice(this.table_index, 1, this.form);
                        this.$message({
                            message: "删除成功！",
                            type: 'success'
                        });
                    }else{
                        alert(res._result.content);
                    }
                })
            },
            handleEdit (index, row) {
                this.dialogFormVisible = true;
                this.form = Object.assign({}, row);
                this.table_index = index;
                //回显ueditor内容
                this.setContent(this.form.NR);
            },
            handleSave () {
                this.$confirm('确认提交吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass: 'cancel'
                }).then(() => {
                    this.editLoading = true;
                    let date = this.form.date;
                    if (typeof date === "object") {
                        date = [date.getFullYear(), (date.getMonth() + 1), (date.getDate())].join('-');
                        this.form.date = date
                    }
//          this.tableData[this.table_index] = this.form;
                    this.zcxwSave({_module:'TT',_method:'zcxwSave',id:this.form.ID,wldz:this.form.WLDZ,"bt": this.form.BT,"xssx": this.form.XSSX,nr:this.getContent(),wbnr:this.getContentTxt()}).then((res) => {  //这是从本地请求的数据接口，
                        if(res._result.type=="success"){
                            this.tableData.splice(this.table_index, 1, this.form);
                            this.$message({
                                message: "操作成功！",
                                type: 'success'
                            });
                        }else{
                            alert(res._result.content);
                        }
                    })
                    this.editLoading = false;
                    this.dialogFormVisible = false;
                }).catch(() => {

                });
            },
            download: function() {
                console.log("xiazai")
                var obj = document.getElementById('download');
                var str = "姓名,出生日期,地址\n";
                for (var i = 0; i < this.tableData.length; i++) {
                    var item = this.tableData[i];
                    str += item.name + ',' + item.date + ',' + item.address;
                    str += "\n";
                }
                console.log(obj)
                str = encodeURIComponent(str);
                console.log(str)
                obj.href = "data:text/csv;charset=utf-8,\ufeff" + str;
                obj.download = "download.csv";
            },
            getContent: function(){
                let content = this.$refs.ueditor.getUEContent();
                return content;
            },
            /*获取纯文本*/
            getContentTxt: function(){
                let content = this.$refs.ueditor.getContentTxt();
                return content;
            },
            setContent: function(obj){
				this.defaultMsg = obj;
				if (this.$refs.ueditor) {
					this.$refs.ueditor.setContent(obj);
				}
            },
        }
    };
</script>
<style>
    .el-pagination {
        text-align: center;
        margin-top: 30px;
    }
    .el-message-box__btns .cancel {
        float: right;
        margin-left: 10px;
    }
    .zwnr .el-form-item__content{
        margin-left:0px !important;
        line-height: 0;
    }
    .el-dialog{
        width: 80%;
    }
</style>
